var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { FixedInt } from './FixedInt';
var Date = /** @class */ (function (_super) {
    __extends(Date, _super);
    function Date() {
        var _this = _super.call(this) || this;
        _this._fixedInt = new FixedInt(8);
        return _this;
    }
    Date.prototype.encodeBuffer = function (value, buffer) {
        this._fixedInt.encodeBuffer(value.getTime(), buffer);
    };
    Date.prototype.decodeBuffer = function (buffer) {
        // @ts-ignore
        return new Date(this._fixedInt.decodeBuffer(buffer));
    };
    return Date;
}(Type));
export { Date };
